module.exports = __webpack_public_path__ + "img/procedure.905d1595.png";